import { styled } from "styled-components";
import { Wrapper } from "@/admin/config/overrides/fieldTypes/styles.ts";

export const ArrayContainer = styled.div<{ $array?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: ${({ theme }) => theme.colors.default[100]};
  border-radius: 8px;

  > div {
    &:first-of-type {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    &:last-of-type {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
`;

export const ArrayWrapper = styled.div`
  ${ArrayContainer} {
    border: none;
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.base};
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: ${({ theme }) => theme.colors.default[50]};
  padding: 0 8px 8px;

  > div {
    &:first-of-type {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    &:last-of-type {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  transition: background 0.2s;
  background: ${({ theme }) => theme.colors.default[50]};
  padding: 4px;
  border-radius: 8px;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  gap: 4px;
`;

export const ItemLabel = styled.p`
  color: ${({ theme }) => theme.colors.default[600]};
  font-size: 0.6em;
  font-weight: 700;
  line-height: 100%;
  text-transform: uppercase;
`;

export const ItemHeader = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  transition: 0.2s;

  > div > button {
    opacity: 0;
  }

  &:hover {
    > div > button {
      opacity: 1;
    }
  }
`;

export const ItemContainerWrapper = styled.div``;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
`;

export const Placeholder = styled.div`
  position: absolute;
  border: dashed 1px ${({ theme }) => theme.colors.secondary.default};
  transition: 0.2s;
`;
